import { darken, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../styles/colors';

const useButtonStyles = makeStyles({
    root: ({ variant, size, color, minWidth, darkColor = false }) => {
        const normalColor = ['brand', 'state', 'grey', 'info', 'succ', 'warn', 'error']?.includes(color) ? color === 'state' ? colors.statew1 : colors[`${color}${darkColor ? '9' : '5'}00`] : color;
        const baseStyle = {
            textTransform: 'capitalize',
            borderRadius: '0.5rem',
            fontWeight: 600,
            minWidth: minWidth ? '7.5rem' : 'unset'
        };

        const sizeStyles = {
            small: {
                fontSize: '0.75rem',
                padding: '0.5rem 1rem',
                lineHeight: '1.25rem'
            },
            medium: {
                fontSize: '0.875rem',
                padding: '0.5rem 1.25rem',
                lineHeight: '1.375rem'
            },
            large: {
                fontSize: '1rem',
                padding: '0.5rem 1.5rem',
                lineHeight: '1.5rem'
            },
        };

        let variantStyles = {};
        let hoverStyles = {};

        switch (variant) {
            case 'primary':
                variantStyles = {
                    border: `1px solid ${color === 'grey' ? colors.grey600 : normalColor}`,
                    backgroundColor: `${color === 'grey' ? colors.grey600 : normalColor} !important`,
                    color: colors.statew1,
                };
                hoverStyles = {
                    '&:hover': {
                        borderColor: darken(color === 'grey' ? colors.grey600 : normalColor, 0.1),
                        backgroundColor: darken(color === 'grey' ? colors.grey600 : normalColor, 0.1),
                    },
                    '@media (hover: none)': {
                        ...variantStyles,
                    }
                };
                break;
            case 'secondary':
                variantStyles = {
                    border: `1px solid ${color === 'grey' ? colors.grey100 : normalColor}`,
                    backgroundColor: 'var(--state-w0) !important',
                    color: color === 'grey' ? colors.grey600 : normalColor,
                };
                hoverStyles = {
                    '&:hover': {
                        backgroundColor: darken(colors.statew1, 0.1),
                        color: darken(normalColor, 0.1),
                    },
                    '@media (hover: none)': {
                        ...variantStyles,
                    }
                };
                break;
            case 'tertiary':
            case 'tertiaryWrap':
                variantStyles = {
                    border: '1px solid transparent',
                    backgroundColor: 'var(--state-w0) !important',
                    color: normalColor,
                    fontWeight: 500,
                };
                hoverStyles = {
                    '&:hover': {
                        color: darken(normalColor, 0.1),
                        border: '1px solid transparent',
                        backgroundColor: colors.statew0,
                    },
                    '@media (hover: none)': {
                        ...variantStyles,
                    }
                };
                break;
            default:
                break;
        }
        if (variant === 'tertiary') {
            variantStyles['padding'] = '0'
        }
        return {
            ...baseStyle,
            ...sizeStyles[size],
            ...variantStyles,
            ...hoverStyles,
            '&.Mui-disabled': {
                opacity: 0.5,
                ...variantStyles
            },
        };
    },
});


export default useButtonStyles;
